import { ComponentProps } from 'react'

import { BodyVariant, FontWeight } from '../../../types/types'

type Props = ComponentProps<'p'> & {
    as?: 'p' | 'span' | 'div'
    variant?: BodyVariant
    weight?: FontWeight
    'data-test'?: string
}

// Component classes, so a utility in className wins by stylesheet order. Concatenate
// instead of twMerge: that merge is the slow part on dense pages.
export const AstraParagraph = ({ children, variant = 'body', weight = 'regular', className, as: Comp = 'p', ...props }: Props) => (
    <Comp className={`astra-${variant} astra-hero-${weight}${className ? ` ${className}` : ''}`} {...props}>
        {children}
    </Comp>
)
